module.exports = __webpack_public_path__ + "img/bg.a4f937e9.png";